import React from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { useParams } from 'react-router-dom';
import useGetRecommendedArticle from '../../hooks/useGetRecommendedArticle/useGetRecommendedArticle';
import useSetPageTitle from '../../hooks/useSetPageTitle/useSetPageTitle';

import PageBanner from '../../common/PageBanner/PageBanner';
import Spinner from '../../components/Spinner/Spinner';

import styles from './RecommendedArticle.module.scss';
import commons from '../../shared/styles/common.module.scss';

const RecommendedArticle = () => {
  const { t } = useTranslation();
  const params = useParams();
  const postId = params.recommendedArticleId;

  const { data, refetch } = useGetRecommendedArticle(Number(postId), false);

  useSetPageTitle({
    pageTitle: `${data?.title} - ${t('general.website-name')}`,
  });

  React.useEffect(() => {
    if (postId) {
      refetch();
    }
  }, [postId, refetch]);

  return !data ? (
    <Spinner variant='green' />
  ) : (
    <div>
      <PageBanner
        title={data.title}
        imageSrc={data.featured_image}
        imageText={data.title}
      />
      <div className={classNames(styles.newsItemContainer, commons.container)}>
        <div>
          <h1
            className={classNames(
              styles.newsItemTitle,
              commons.subSectionHeading,
            )}>
            {data.title}
          </h1>
          <div className={styles.newsItemContent}>{parse(data.content)}</div>
          <img
            src={data.featured_image}
            alt={data.title}
            className={styles.newsItemContentImage}
          />
        </div>
      </div>
    </div>
  );
};

export default RecommendedArticle;
